<template lang="pug">
div
  .d-flex.justify-content-start.gap-4
    button.btn-primary-outline.text-nowrap.mb-4(
      @click='$emit("downloadExample")'
      style='border-width: 1px'
      type='button'
    )
      span.text {{ $t('configureBulkSend.recipients.downloadCsvExample') }}
  .card.card--file-loader.mb-5
    .card-body(
      :class='["dropzone-area", dragging ? "dragenterClass" : ""]'
      @dragend='dragging = false'
      @dragenter='dragging = true'
      @dragleave='dragging = false'
      @dragover.prevent='dragover'
      @drop.prevent='drop'
    )
      input(
        :accept='allowedFileType.join()'
        multiple='multiple'
        ref='inputFile'
        style='display: none'
      )
      label.notclickable.block.cursor-pointer(for='assetsFieldHandle')
        h3.card-title {{ $t('configureBulkSend.recipients.upload.dragHere') }}
        p.font-size-subtitle.mb-2 {{ $t('configureBulkSend.recipients.upload.or') }}
        button.btn.btn-thin(@click='openfileUploadModal') {{ $t('configureBulkSend.recipients.upload.searchIn') }}
        p.font-size-small.mb-0.mt-2
          | {{  $t('configureBulkSend.recipients.upload.fileExtensions',{ extensions: `\"${allowedFileExtensions.join('\", \"')}\"`, maxFileSizeMb: maxUploadSizeMB })  }}
        p.font-size-small.mb-0 {{ $t('configureBulkSend.recipients.upload.maxFilesPerUpload', { maxFilesPerUpload }) }}
        p.font-size-small.mb-0 {{ $t('configureBulkSend.recipients.upload.maxSizePerUpload', { maxUploadSizeMB: maxUploadSizeMB }) }}
        p.font-size-small.mb-0 {{ $t('configureBulkSend.recipients.upload.maxCsvFileRowsLimit', { maxCsvFileRowsLimit: maxFileRowsLimit }) }}
  .files-list.mb-5(v-if='uploadedFile')
    h6.mb-4 {{ $t('configureBulkSend.recipients.selectedFiles') }}
    .w-100.d-flex.flex-wrap
      .clearfix.mb-4.col-md-3.col-sm-4(v-if='uploadedFile')
        .file-item(:title='uploadedFile.name')
          .actions
          .preview.d-flex(style='background-color: #f0f0f0')
            icon(name='file-lines')
          .file-name {{ uploadedFile.name }}

  file-local-loader-modal(
    :allowed-file-extensions='allowedFileExtensions'
    :allowed-file-type='allowedFileType'
    :aux-button-label='$t("modal.file_loader.select_files")'
    :aux-button-show='false'
    :isBulkSend='true'
    :max-file-rows-limit='maxFileRowsLimit'
    :max-file-size-mb='maxUploadSizeMB'
    :sourceStorage='false'
    :title='$t("modal.file_loader.title")'
    @selected-files='$emit("onSelectFiles", $event)'
    ref='fileUpload'
  )
</template>
<script>
import FileLocalLoaderModal from '@/ui/organisms/modals/FileLocalLoaderModal.vue';
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'BulkSendUploadArea',
  components: {
    FileLocalLoaderModal,
    Icon,
  },
  props: {
    uploadedFile: {
      type: Object,
      default: null,
    },
    allowedFileType: {
      type: Array,
      required: true,
    },
    allowedFileExtensions: {
      type: Array,
      required: true,
    },
    maxFilesPerUpload: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    maxUploadSizeMB() {
      return (
        this.$store.getters['envelopeConfig/bulkSendMaxUploadSizeMB'] || 25
      );
    },
    maxFileRowsLimit() {
      return (
        this.$store.getters['envelopeConfig/bulkSendFileRowsLimit'] || 10000
      );
    },
  },
  data() {
    return {
      dragging: false,
    };
  },
  methods: {
    dragover(event) {
      event.preventDefault();
    },
    drop(event) {
      event.preventDefault();
      this.$refs.fileUpload.$refs.modal.open();
      this.$refs.fileUpload.loadFile(event, true);
      this.dragging = false;
    },
    openfileUploadModal() {
      this.$refs.fileUpload.$refs.modal.open();
    },
  },
};
</script>

<style scoped lang="stylus">
.card--file-loader
  text-align: center
  border: 2px dashed #3ECB90
  color: #013D52
  padding: 1rem
  box-shadow: 0 3px 5px #00000029
  &:hover
    background-color: #eaeaea
  .card-title
    font-size: 1.5rem
  .btn
    padding-left: 1rem
    padding-right: 1rem
  .dragenterClass
    cursor: grabbing
    cursor: -webkit-grabbing
    background:rgba(0,0,0,0.1)
    .notclickable
      pointer-events: none
      h3
        pointer-events: none
      p
        pointer-events: none

.files-list .file-item
  position: relative
  border: 1px solid #CCCCCC
  border-radius: 3px
  max-width: 250px
  margin: auto
  margin-left: 0
  .preview
    width: 100%
    height: 110px
    border-top-left-radius: 3px
    border-top-right-radius: 3px
    background-size: cover
    background-position: initial
    background-repeat: no-repeat
    text-align: center
    .icon
      color: #949494
      font-size: 2.5em
      margin: auto
  .file-name
    border-radius: 0 0 3px 3px
    font-size: 0.9rem
    margin-top: -6px
    padding: 10px 7px
    padding-right: 23px
    overflow: hidden
    text-overflow: ellipsis
    background: #fff
    white-space: nowrap
  .file-error
    border-radius: 0 0 3px 3px
    font-size: 0.9rem
    margin-top: -3px
    padding: 10px 7px
    padding-right: 50px
    white-space: normal
    word-break break-word
    overflow: hidden
    text-overflow: clip
    color: #721C24
  .actions
    position: absolute
    bottom: 8px
    right: 4px
    button
      color: #949494
  .danger
    color: #721C24
    background-color: #f8d7da
    border-color: #F5C6CB

  &:has(.file-error)
    .actions button
      color: #721C24
      &:hover
        color: #949494
</style>
